import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TokenInterceptor } from './interceptors/token-interceptor';
import { environment } from './../environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, ApplicationRef, ErrorHandler } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { CommonModule } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ContentModule } from './content/content.module';
import {
  LogLevel,
  AuthModule as OIDCAuthModule,
} from 'angular-auth-oidc-client';

import { LayoutModule } from './layout/layout.module';
import { MaterialModule } from './material/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppConfigService } from './app.config.service';
import { ErrorHandlerService } from './utilities/logging.service';
import { GlpCommonModule } from './glp-common/glp-common.module';
import { HomeModule } from './content/home/home.module';
import { provideAuth0 } from '@auth0/auth0-angular';
import { UserService } from './services/user.service';
import { getAuth0ClientId } from './portal-config';

export function loadConfigService(configService: AppConfigService): Function {
  return () => {
    return configService.load();
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule,
    ContentModule,
    FormsModule,
    ReactiveFormsModule,
    LayoutModule,
    MaterialModule,
    GlpCommonModule,
    BrowserAnimationsModule,
  ],

  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerService
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfigService,
      deps: [AppConfigService, Sentry.TraceService],
      multi: true,
    },
    provideAuth0({
      domain: environment.auth0Domain,
      clientId: getAuth0ClientId(),
      useRefreshTokens: true,
      useRefreshTokensFallback: true,
      cacheLocation: 'localstorage',
      authorizationParams: {
        redirect_uri: window.location.origin,
        audience: environment.auth0Audience,
        connection: 'BCBSNE',
        scope: 'openid profile email'
      }
    }),
    
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
